
import { useState, useEffect, useCallback } from 'react';
import { accountSignatoryService } from '../api/accountSignatoryService';
import { toast } from 'sonner';

export const useAccountSignatories = (accountId) => {
  const [data, setData] = useState({
    signatories: [],
    stats: null,
    pagination: null,
    loading: false,
    error: null
  });

  const [filters, setFilters] = useState({
    pageNumber: 1,
    pageSize: 10,
    searchTerm: '',
    typeSignature: null,
    estSignatairePrincipal: null,
    estRepresentantLegal: null,
    sortBy: 'CreationDate',
    sortDescending: true
  });

  const fetchSignatories = useCallback(async () => {
    if (!accountId) return;

    setData(prev => ({ ...prev, loading: true, error: null }));

    try {
      const [signatoriesResult, statsResult] = await Promise.all([
        accountSignatoryService.getPaginated(accountId, filters),
        accountSignatoryService.getStats(accountId)
      ]);
      
      if (signatoriesResult.success && statsResult.success) {
        setData({
          signatories: signatoriesResult.data,
          stats: statsResult.data,
          pagination: signatoriesResult.pagination,
          loading: false,
          error: null
        });
      } else {
        throw new Error('Erreur lors du chargement des données');
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Erreur de chargement';
      setData(prev => ({
        ...prev,
        loading: false,
        error: errorMessage
      }));
      toast.error(errorMessage);
    }
  }, [accountId, filters]);

  const deleteSignatory = async (id) => {
    try {
      const result = await accountSignatoryService.delete(id);
      
      if (result.success) {
        toast.success('Signataire supprimé avec succès');
        await fetchSignatories();
        return true;
      } else {
        throw new Error(result.message || 'Erreur lors de la suppression');
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Erreur de suppression';
      toast.error(errorMessage);
      return false;
    }
  };

  useEffect(() => {
    fetchSignatories();
  }, [fetchSignatories]);

  return {
    signatories: data.signatories,
    stats: data.stats,
    pagination: data.pagination,
    loading: data.loading,
    error: data.error,
    filters,
    setFilters,
    refetch: fetchSignatories,
    deleteSignatory
  };
};